import {
  SearchParameters,
  SearchParametersFactory,
  type SearchQuery,
} from 'app/domain';
import { toQueryKeyAndValue } from 'app/support/searchParameterMapping';
import { PRESERVES_EXPLICIT_FALSE } from './explicitSignals';
import { LegacySearchParameters } from './types';

const factory = new SearchParametersFactory();

const stringify = (key: string, value: unknown): string | undefined => {
  if (value === false && PRESERVES_EXPLICIT_FALSE.has(key)) return 'false';
  if (!value) return undefined;
  if (Array.isArray(value)) return value.length ? value.join(',') : undefined;
  return String(value);
};

const toSearchQuery = (legacy: LegacySearchParameters): SearchQuery => {
  const query: Record<string, string | undefined> = {};
  Object.entries(legacy).forEach(([name, value]) => {
    const mapped = toQueryKeyAndValue(name, value) as
      | { key: string; value: unknown }
      | undefined;
    if (!mapped) return;
    const stringValue = stringify(mapped.key, mapped.value);
    if (stringValue === undefined) return;
    const existing = query[mapped.key];
    query[mapped.key] = existing ? `${existing},${stringValue}` : stringValue;
  });
  return query;
};

export const searchParameterAdapter = (
  legacySearchParameters: LegacySearchParameters
): SearchParameters => factory.fromQuery(toSearchQuery(legacySearchParameters));
